// extracted by mini-css-extract-plugin
export default {"noData":"NoData_noData__lE4ky"};